import certificatePaotang from "@/service/certificatePaotang.api";

const state = {
};

const mutations = {
};

const getters = {
};

const actions = {

  async GetInvestCert({ dispatch, commit }, req) {
    return await certificatePaotang.GetInvestCert(req)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  async DownloadCertificate({ dispatch, commit }, req) {
    return await certificatePaotang.DownloadCertificate(req)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
